import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Booking service — clearly named functions for the public appointment
 * journey. All availability is calculated server-side; the frontend never
 * assumes a slot exists. The future admin area manages meeting types,
 * availability windows and blocked periods through the same backend.
 */
export async function getMeetingTypes() {
  const { data } = await axios.get(`${API}/booking/meeting-types`);
  return data;
}

export async function getAvailability(meetingType, month) {
  const { data } = await axios.get(`${API}/booking/availability`, {
    params: { meetingType, month },
  });
  return data;
}

export async function createBooking(payload) {
  const { data } = await axios.post(`${API}/booking/bookings`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return data;
}

export async function getBooking(reference, token) {
  const { data } = await axios.get(`${API}/booking/bookings/${reference}`, {
    params: { token },
  });
  return data;
}

export async function cancelBooking(reference, payload) {
  const { data } = await axios.post(`${API}/booking/bookings/${reference}/cancel`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return data;
}

export async function rescheduleBooking(reference, payload) {
  const { data } = await axios.post(`${API}/booking/bookings/${reference}/reschedule`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return data;
}

export function bookingIcsUrl(reference, token) {
  return `${API}/booking/bookings/${reference}/ics?token=${encodeURIComponent(token)}`;
}
